import { useEffect, useMemo, useState } from 'react';

interface useApexApiReqProps {
  url: string;
  options?: RequestInit;
}

export const useApexApiReq = <T>({ url, options }: useApexApiReqProps) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchdata = useMemo(
    () => async () => {
      try {
        setLoading(true);
        const response = await fetch(url, options);
        const result = await response.json();
        setData(result);
      } catch (err: unknown) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    },
    [url, options],
  );

  useEffect(() => {
    if (!data && !error && !loading) {
      fetchdata();
    }
  }, [fetchdata, data, error, loading]);

  return { loading, data, error };
};
